<template>
  <div class="Documento">
    <div class="Documento_delete"
         @click="deleteDocumento()">
      <icon-svg class="Documento_delete_icon"
                icon="trash" />
    </div>
    <div @click="showDocumento()">
      <svg class="Documento_icon"
           role="presentation">
        <use :xlink:href="'#' + outros.id" />
      </svg>
    </div>
    <div class="Documento_name"
         @click="showDocumento()">
      {{ propDocumento.name || `Arquivo ${propIndex + 1}` }}
    </div>
    <b-modal v-if="showModal"
             id="visualizarDoc"
             ref="visualizarDoc"
             size="xl"
             visible
             hide-header
             @hidden="showModal = false">
      <object v-if="documentoUrl"
              class="embed-preview embed-responsive"
              :data="documentoUrl"
              type="application/pdf">
        <p>Seu browser não suporta arquivos pdf diretamente ou este arquivo não existe. Você pode tentar efetuar o download clicando <a :href="documentoUrl">aqui</a>.</p>
      </object>
      <div slot="modal-footer"
           slot-scope="{ cancel }">
        <button class="btn btn-secondary mr-2"
                @click="cancel()">
          Voltar
        </button>
      </div>
    </b-modal>
  </div>
</template>

<script>
  import outros from '@/assets/icons/outros.svg?sprite'
  export default {
    name: 'Documento',
    props: {
      propDocumento: {type: [File, ArrayBuffer], default: () => ({})},
      propIndex: {type: Number, default: null}
    },
    data () {
      return {
        outros,
        showModal: false,
        documentoUrl: null
      }
    },
    methods: {
      deleteDocumento () {
        this.$emit('deleteDocumento', this.propIndex)
      },
      showDocumento () {
        let blob = new Blob([this.propDocumento], { type: 'application/pdf' })
        this.documentoUrl = window.URL.createObjectURL(blob)

        this.showModal = true
      }
    }
  }
</script>

<style lang="scss">
.Documento {
    position: relative;
    margin-right:10px ;
    box-shadow: 0 0 2px 0 #c6c6c6;
    display: flex;
    flex-direction: column;
    align-items: center;
    padding: 5px;
    cursor: pointer;
    width: 100px;

    &_name {
      width: 99px;
      white-space: nowrap;
      overflow: hidden;
      text-overflow: ellipsis;
      text-align: center;
    }

    &_delete {
      position: absolute;
      top: 0px;
      left: 0px;
      cursor: pointer;
      background: rgb(100, 0, 0);
      border-radius: 50px;

      &_icon {
        width: 25px;
        height: 25px;
        padding: 5px;
        margin: 0px;
        fill: #fff;
      }
    }

    &_icon {
      width: 50px;
      height: 50px;
    }
  }
</style>
